import React from 'react';

import { isMobile } from '../../utils/devices';
import { MessagesPage } from '@mavenmachines/maven-messages';
import { Page } from '../layout/Page';
import './messages.scss';
import config from '../../configs/companies.config';
import { useSelector } from 'react-redux';
import { getDriverInfo, getDriverPermissions } from '../profile/store';
import { ENV_VALUES } from '../../configs/types';
import { PermissionDenied } from '../auth/permissionDenied/PermissionDenied';
import { PERMISSIONS } from '../../constants/permissionsConstants';

const NODE_ENV = process.env.NODE_ENV;

export const MessagesWrapper: React.FC = () => {
  const driverInfo = useSelector(getDriverInfo);
  const permissions = useSelector(getDriverPermissions);

  const companyConfig = (config as { [key in ENV_VALUES]: any })[NODE_ENV as ENV_VALUES] || {};
  const configData = companyConfig[`${driverInfo.companyId}`];
  const messagesOptions = configData?.messagesOptions || {};

  if (!permissions.length) return null;

  return permissions.includes(PERMISSIONS.APP_MESSAGES_ACCESS) ? (
    <Page>
      <MessagesPage options={{ ...messagesOptions, isMobile: isMobile, isDriver: true }} />
    </Page>
  ) : (
    <PermissionDenied />
  );
};
